import { render, staticRenderFns } from "./AddNewAgency.vue?vue&type=template&id=2204d597&"
import script from "./AddNewAgency.vue?vue&type=script&lang=js&"
export * from "./AddNewAgency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports